import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import moment from 'moment';
import { scanResult, skinAnalyserDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import ReusablePagination from 'components/commom/Pagination';
import {
  basicDetailsValue,
  SCAN_DETAILS,
  SCAN_RESULT,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import LabelWithInput from 'components/commom/LabelWithInput';
import { getScanAnalysisCallAPI } from 'store/getScanAnalysis/action';

const SkinAnalyser = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const intl = useIntl();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    userFilter: 'All',
    startDate: '',
    endDate: '',
    search: '',
    dateType: 'Select',
  });
  const [formDataSlug, setFormDataSlug] = useState({
    userFilter: 'all',
    dateType: 'Select',
  });
  const itemsPerPage = 10;

  const scanAnalysisList = useSelector(
    (state) => state?.getScanAnalysisReducer?.users
  );

  const selectDateList = [
    {
      id: 1,
      name: 'Select',
      slug: 'Select',
    },
    {
      id: 2,
      name: 'Today',
      slug: 'Today',
    },
    {
      id: 3,
      name: 'Yesterday',
      slug: 'Yesterday',
    },
    {
      id: 4,
      name: 'Last 7 Days',
      slug: 'Last 7 Days',
    },
    {
      id: 5,
      name: 'Last 15 Days',
      slug: 'Last 15 Days',
    },
    {
      id: 6,
      name: 'Last 30 Days',
      slug: 'Last 30 Days',
    },
    {
      id: 7,
      name: 'Custom',
      slug: 'Custom',
    },
  ];

  const userFilterData = [
    { id: 1, name: 'User', slug: 'user' },
    { id: 2, name: 'Guest User', slug: 'guest-user' },
    { id: 3, name: 'All', slug: 'all' },
  ];

  useEffect(() => {
    initialState();
    getScanAnalysisList('all', '', '', '', 1);
    setLoading(true);
  }, []);

  const initialState = () => {
    setFormData({
      userFilter: 'All',
      startDate: '',
      endDate: '',
      search: '',
      dateType: 'Select',
    });
    setFormDataSlug({
      userFilter: 'all',
      dateType: 'Select',
    });
  };

  const getScanAnalysisList = (type, startDate, endDate, search, pageCount) => {
    const data = `?page=${pageCount}${search && `&searchtext=${search}`}${startDate && `&start_date=${startDate}`}${endDate && `&end_date=${endDate}`}${type !== 'all' ? `&role=${type}` : ''}`;
    const external = {
      run: true,
      handleFunction: (res) => {
        setLoading(false);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    dispatch(getScanAnalysisCallAPI(data, external));
  };

  const handleDetail = (data) => {
    if (data?.total_scans === 1) {
      dispatch(basicDetailsValue(SCAN_DETAILS, data));
      dispatch(basicDetailsValue(SCAN_RESULT, data?.scan_details[0]));
      navigate(scanResult(locale));
    } else {
      dispatch(basicDetailsValue(SCAN_DETAILS, data));
      navigate(skinAnalyserDetail(locale));
    }
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getScanAnalysisList(
      formDataSlug?.userFilter,
      formData?.startDate,
      formData?.endDate,
      formData?.search,
      value
    );
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    setFormDataSlug((prev) => ({
      ...prev,
      [name]: value?.slug,
    }));

    switch (value?.slug) {
      case 'Today':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
          formData?.search,
          1
        );
        setLoading(true);
        break;

      case 'Yesterday':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD'),
          formData?.search,
          1
        );
        setLoading(true);
        break;

      case 'Last 7 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(6, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          moment().subtract(6, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
          formData?.search,
          1
        );
        setLoading(true);
        break;

      case 'Last 15 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(14, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          moment().subtract(14, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
          formData?.search,
          1
        );
        setLoading(true);
        break;

      case 'Last 30 Days':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: moment().subtract(29, 'days').format('YYYY-MM-DD'),
          ['endDate']: moment().format('YYYY-MM-DD'),
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          moment().subtract(29, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
          formData?.search,
          1
        );
        setLoading(true);
        break;
      case 'Custom':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));
        break;
      case 'Select':
        setFormData((prev) => ({
          ...prev,
          ['startDate']: '',
          ['endDate']: '',
        }));
        getScanAnalysisList(
          formDataSlug?.userFilter,
          '',
          '',
          formData?.search,
          1
        );
        setLoading(true);
        break;

      default:
        break;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (formData?.startDate && name === 'endDate') {
      getScanAnalysisList(
        formDataSlug?.userFilter,
        formData?.startDate,
        value,
        formData?.search,
        1
      );
      setLoading(true);
    }
    if (formData?.endDate && name === 'startDate') {
      getScanAnalysisList(
        formDataSlug?.userFilter,
        value,
        formData?.endDate,
        formData?.search,
        1
      );
      setLoading(true);
    }
    if (name === 'search') {
      getScanAnalysisList(
        formDataSlug?.userFilter,
        formData?.startDate,
        formData?.endDate,
        value,
        1
      );
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    setFormDataSlug((prev) => ({
      ...prev,
      [name]: value?.slug,
    }));
    getScanAnalysisList(
      value?.slug,
      formData?.startDate,
      formData?.endDate,
      formData?.search,
      1
    );
    setLoading(true);
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              <FormattedMessage id="Skin Analyser" />
            </h2>
          </div>
          {
            <Row
              className="mt-3 mb-5 g-5"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Filter by:'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder="Select"
                    name={'userFilter'}
                    value={formData?.userFilter}
                    data={userFilterData}
                    onChange={(e) => handleChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </Col>
              <Col md={2} className="mt-4">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Select Date:'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder={intl.formatMessage({
                      id: 'Select Date',
                    })}
                    name={'dateType'}
                    value={formData?.dateType || ''}
                    data={selectDateList}
                    onChange={(e) => handleDateChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </Col>
              {formDataSlug?.dateType === 'Custom' && (
                <>
                  <Col md={2} className="mt-2">
                    <div>
                      <LabelWithInput
                        label="Start Date"
                        type="date"
                        name="startDate"
                        value={formData?.startDate}
                        disabled={false}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </div>
                  </Col>
                  <Col md={2} className="mt-2">
                    <div>
                      <LabelWithInput
                        label="End Date"
                        type="date"
                        name="endDate"
                        value={formData?.endDate}
                        disabled={false}
                        onChange={(e) => {
                          handleInputChange(e);
                        }}
                      />
                    </div>
                  </Col>
                </>
              )}
            </Row>
          }
          {loading ? (
            <Loader />
          ) : (
            <div className="pt-20 mb-[50px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={5} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Patient & ID" />
                  </p>
                </Col>
                <Col lg={5} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Contact Info" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Total Used Scan" />
                  </p>
                </Col>
                {/* <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col> */}
              </Row>
              {scanAnalysisList && scanAnalysisList?.data?.length > 0 ? (
                <Row className="bc-FFFFFF m-0 p-0">
                  {scanAnalysisList?.data?.map((item, index) => {
                    return (
                      <Row
                        className="m-0 p-0 flex items-center listAppointment"
                        key={index}
                      >
                        <Col
                          lg={5}
                          md={6}
                          sm={12}
                          className="cursor-pointer"
                          onClick={() => handleDetail(item)}
                        >
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {item?.patient_info?.full_name}
                          </div>
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                            {item?.patient_info?.patient_id}
                          </div>
                        </Col>
                        <Col lg={5} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <Image src={mail} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                              {item?.patient_info?.email}
                            </div>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center pt-04"
                          >
                            <Image src={call} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                              {item?.patient_info?.country_code}{' '}
                              {item?.patient_info?.contact_number}
                            </div>
                          </Stack>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.total_scans}
                          </div>
                        </Col>
                        {/* <Col lg={2} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="items-center cursor-pointer"
                          >
                            <div
                              className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                              onClick={() => handleDetail(item)}
                            >
                              <FormattedMessage id="View Details" />
                            </div>
                            <Image
                              src={ArrowRightIcon}
                              alt="icon"
                              onClick={() => handleDetail(item)}
                            />
                          </Stack>
                        </Col> */}
                      </Row>
                    );
                  })}
                </Row>
              ) : (
                <div className="flex justify-center pt-120">
                  <div>
                    <Image src={EmptyScreen} alt="icon" />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SkinAnalyser;
